'use strict'
import {
    formateQuery
} from './formate'

function Audio5(params) {
    // <audio>元素
    this.audioEle = null;
    // 当前播放速率
    this.playbackRate = 1;
    let _that = this;
    (function () {
        // 默认初始值
        let conf = {
            ele: document.body,
            autoplay: false,
            preload: 'metadate',
            volume: 0.75,
            muted: true,
            playbackRate: 1,
            theme: 'none',
        }
        // 初始值合并传参
        conf = formateQuery(conf, params);

        // new Audio()
        let oAudio = new Audio();
        oAudio.loop = false;
        oAudio.controls = false;
        if (conf.theme == 'default') {
            oAudio.controls = true;
        } else if (conf.theme == 'none') {
            oAudio.setAttribute('hidden', true);
        }
        oAudio.volume = conf.volume;
        oAudio.muted = conf.muted;
        oAudio.preload = conf.preload;
        oAudio.autoplay = conf.autoplay;
        oAudio.playbackRate = conf.playbackRate;
        conf.ele.appendChild(oAudio);

        // 缓存：audio元素，循环模式
        _that.audioEle = oAudio;


    })()
}

Audio5.prototype = {
    constructor: Audio5,

    // ========== 播放器控件
    load(date) {
        if (!this.audioEle) {
            return
        }
        this.audioEle.src = date.url ? date.url : date;
        this.audioEle.load();
        if (this.audioEle.autoplay) {
            this.play();
        }
    },
    togPause() {
        if (!this.audioEle) {
            return
        }
        if (this.audioEle.paused) {
            this.audioEle.play();
        } else {
            this.audioEle.pause();
        }
    },
    togMuted() {
        if (!this.audioEle) {
            return
        }
        this.audioEle.muted = !this.audioEle.muted;
    },
    volume(num) {
        let temp = parseFloat(num);
        if (!this.audioEle && isNaN(temp)) {
            return
        }
        if (temp >= 1) {
            temp = 1
        } else if (temp <= 0) {
            temp = 0
        } else {
            temp = temp.toFixed(2);
        }
        this.audioEle.volume = temp;
    },
    seekTo(percent) {
        if (!this.audioEle) {
            return
        }
        if (percent >= 0 && percent <= 1) {
            this.audioEle.currentTime = parseInt(this.audioEle.duration * percent);
        }
    },
    togControls(){
        if (!this.audioEle) {
            return
        }
        this.audioEle.controls = !this.audioEle.controls
    },
    reload() {
        this.audioEle.src = '';
        this.audioEle.load()
    },
    getMate() {
        // 获取的元信息
        return this.audioEle
    },
    on(name, callback) {
        this.audioEle.addEventListener(name, callback)
    }
}

export default Audio5